import React from 'react';

import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { useMediaQuery } from 'react-responsive';

import { isTab } from '../../Utils/Utils';

const getItems = () =>
    Array(20)
        .fill(0)
        .map((_, ind) => ({ id: `element-${ind}` }));

const data = [
    {
        "id": "slider_1",
        "img": "images/Mask_Group_256.png",
        "heading": "Favipiravir",
        "desc": "We tied up with Japan’s Fujifilm Toyama Chemical, innovators of Favipiravir, to make the product accessible to Covid-19 patients around the world. Favipiravir is an oral antiviral drug that works by inhibiting the multiplication of the virus in the body."
    },
    {
        "id": "slider_2",
        "img": "images/Mask_Group_258.png",
        "heading": "Remdesivir",
        "desc": "Through a partnership with US company Gilead Sciences, innovators of Remdesivir, we’re making this antiviral drug available for Covid-19 patients globally. Remdesivir is an injectable product that stops the multiplication of the virus in the body."
    },
    {
        "id": "slider_3",
        "img": "images/Mask_Group_261.png",
        "heading": "Molnupiravir",
        "desc": "We’re working with Merck Sharp & Dohme to make Molnupiravir accessible to Covid-19 patients globally. It is an oral antiviral drug that inhibits multiplication of the virus in the body. We manufacture the active ingredient as well as the formulation."
    },
    {
        "id": "slider_4",
        "img": "images/Mask_Group_262.png",
        "heading": "2-DG",
        "desc": "In collaboration with India’s Defence Research and Development Organisation, we produce 2-deoxy-D-glucose or 2-DG to treat Covid-19. 2-DG is an oral antiviral and anti-inflammatory drug used as an adjunct therapy."
    },
    {
        "id": "slider_5",
        "img": "images/Mask_Group_263.png",
        "heading": "Baricitinib",
        "desc": "We have partnered with the US-based Eli Lilly and Company, innovators of Baricitinib, to bring the product to India. Baricitinib is an oral drug that reduces the body’s unwanted inflammatory response to Covid-19."
    },
    {
        "id": "slider_6",
        "img": "images/national-cancer-institute-kooSjlL8LnQ-unsplash.png",
        "heading": "Liposomal Amphotericin B",
        "desc": "The drug was repurposed drug for the treatment of Mucormycosis (black fungus). We received approval in India in June 2021."
    },
]
    ;

const TreatmentSlider = ({ }) => {
    const [items, setItems] = React.useState(data);
    // const [items, setItems] = React.useState(getItems);
    const [selected, setSelected] = React.useState([]);
    const [position, setPosition] = React.useState(0);

    const [readMore, setReadMore] = React.useState([]);

    const isItemSelected = (id) => !!selected.find((el) => el === id);

    const isMobile = useMediaQuery({ query: "(max-width: 820px)" });


    const handleClick =
        (id) =>
            ({ getItemById, scrollToItem }) => {
                const itemSelected = isItemSelected(id);

                setSelected((currentSelected) =>
                    itemSelected
                        ? currentSelected.filter((el) => el !== id)
                        : currentSelected.concat(id)
                );
            };

    const renderText = (id, text, limit) => {
        if (text) {
            return (text.length > limit) || readMore.indexOf(id) !== -1 ? text.substr(0, limit - 1) + '...' : text;
        }
    }

    const Card = ({ onClick, selected, item, itemId, index, setVisisbleCard }) => {
        const visibility = React.useContext(VisibilityContext);

        if (!!visibility.isItemVisible(itemId)) {
            setVisisbleCard(index);
        }

        var title = renderText(item.id, item.desc, 100);

        return (
            <div
                style={{
                    width: isTab?'36vw':'70vw',
                    marginRight: data.length - 1 === index ? isTab ? '10vw' : '20px' : '0px',
                    marginLeft: index === 0 ? isTab ? '10vw' : '20px' : '25px',
                }}
            >
                <div style={{ overflow: 'hidden', width: '100%', height: '200px', marginBottom: '12px' }} >
                    <img src={item.img} loading="lazy" alt style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ marginBottom: '10px', fontWeight: 700, color: '#333', textAlign: 'left', fontSize: '16px' }} >{item.heading}</div>
                {
                    readMore.indexOf(item.id) !== -1
                        ?
                        <div style={{ marginBottom: '10px', fontWeight: 300, color: '#333', textAlign: 'left', fontSize: '16px' }} >
                            {item.desc}
                        </div>
                        :
                        <div style={{ marginBottom: '10px', fontWeight: 300, color: '#333', textAlign: 'left', height: '80px', fontSize: '16px' }} >
                            {title}
                            {title.includes('...') && <span style={{ color: '#5225B5', fontSize: '16px', fontWeight: 'bold' }} onClick={() => {
                                console.log(readMore)
                                setReadMore([...readMore, item.id])
                            }} >Read More</span>}
                        </div>
                }
            </div>
        )

        // return (
        //     <div
        //         onClick={() => onClick(visibility)}
        //         style={{
        //             width: '70vw',
        //             marginRight: '25px'
        //         }}
        //         tabIndex={0}
        //     >
        //         <div className="card">
        //             <div>{title}</div>
        //             <div>visible: {JSON.stringify(!!visibility.isItemVisible(itemId))}</div>
        //             <div>selected: {JSON.stringify(!!selected)}</div>
        //         </div>
        //         <div
        //             style={{
        //                 height: '200px',
        //             }}
        //         />
        //     </div>
        // );
    }

    return (

        isMobile && data.length !== 0 && <>
            <div style={{ borderTop: '1px solid #ff5046' }} >
                <div style={{ marginTop: '24px', marginLeft:isTab ? '-10vw' : '-20px', marginRight: isTab ? '-10vw' : '-20px', width: isTab ? 'calc(100% + 10vw + 10vw)' :'calc(100% + 20px + 20px)' }} >
                    <ScrollMenu>
                        {data.map((item, index) => (
                            <Card
                                itemId={item.id} // NOTE: itemId is required for track items
                                item={item}
                                key={item.id}
                                index={index}
                                onClick={handleClick(item.id)}
                                selected={isItemSelected(item.id)}
                                setVisisbleCard={(index) => {
                                    setPosition(index)
                                }}
                            />
                        ))}
                    </ScrollMenu>
                </div>
            </div>
            <div style={{ display: 'flex', height: '2px', width: '100%', flexDirection: 'row', backgroundColor: '#a8a8a8', position: 'relative', marginTop: '30px' }} >
            {
                isTab
                ?
                <div style={{ height: '3px', backgroundColor: '#ff5046', position: 'absolute', left: ((position-1) * (100 / (data.length-1))) + '%', top: '-0.5px', right: 'auto', bottom: '0%', width: (100 / (data.length-1)) + "%" }} />
                :
                <div style={{ height: '3px', backgroundColor: '#ff5046', position: 'absolute', left: (position * (100 / data.length)) + '%', top: '-0.5px', right: 'auto', bottom: '0%', width: (100 / data.length) + "%" }} />
            }
            </div>
        </>
    );
}

export default TreatmentSlider;